// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"bb3eadd2","180":"15d438b8","208":"035487e3","631":"7c471424","774":"216caafd","787":"12e506e7","820":"252de593","910":"43b91eec"}[chunkId] + ".chunk.js";
};